// Lightweight article parser: turns plain/markdown-ish content into blocks
// and extracts an "İçindekiler" (table of contents) from "## " headings.

export function slugifyTr(s = "") {
  const map = { ç: "c", ğ: "g", ı: "i", İ: "i", ö: "o", ş: "s", ü: "u", Ç: "c", Ğ: "g", Ö: "o", Ş: "s", Ü: "u" };
  return s
    .replace(/[çğıİöşüÇĞÖŞÜ]/g, (m) => map[m] || m)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export function parseArticle(content = "") {
  const lines = content.split("\n");
  const blocks = [];
  const toc = [];
  let list = null;
  const flush = () => {
    if (list) {
      blocks.push(list);
      list = null;
    }
  };
  lines.forEach((raw) => {
    const line = raw.trim();
    if (!line) {
      flush();
      return;
    }
    if (line.startsWith("## ")) {
      flush();
      const text = line.slice(3).trim();
      const id = slugifyTr(text);
      toc.push({ id, text });
      blocks.push({ type: "h2", text, id });
    } else if (line.startsWith("### ")) {
      flush();
      blocks.push({ type: "h3", text: line.slice(4).trim() });
    } else if (/^\d+\.\s/.test(line)) {
      if (!list || list.type !== "ol") {
        flush();
        list = { type: "ol", items: [] };
      }
      list.items.push(line.replace(/^\d+\.\s/, ""));
    } else if (/^[-•]\s/.test(line)) {
      if (!list || list.type !== "ul") {
        flush();
        list = { type: "ul", items: [] };
      }
      list.items.push(line.replace(/^[-•]\s/, ""));
    } else {
      flush();
      blocks.push({ type: "p", text: line });
    }
  });
  flush();
  return { toc, blocks };
}

export function readingTime(content = "") {
  const words = content.trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
}
